import React, { useState, useEffect } from "react";
import { LensProduct } from '@/features/facility/orders/types';
import getCommercialLens from '@/features/facility/orders/api/getCommercialLens';

const Main: React.FC = () => {
  const [products, setProducts] = useState<LensProduct[]>([]);
  const [currentHash, setCurrentHash] = useState(window.location.hash);
  const [shouldDisplayHD, setShouldDisplayHD] = useState(false);
  const [shouldDisplayTD, setShouldDisplayTD] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await getCommercialLens();
      setProducts(response.data.products);
    };

    fetchProducts();
  }, []);


  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    setShouldDisplayHD(products.some(product => product.itemCode === "17300"));
    setShouldDisplayTD(products.some(product => product.itemCode === "17310"));
  }, [currentHash, products]);

  return (
    <React.Fragment>
      <main id="page-stock" className="wrapper">
        <section className="sec-contact sec-contact--infor">
          <div className="inner">
            <div className="sec-contact__item mbpc-83">
              <h1 className="c-ttl__01 mbsp-18">在庫確認</h1>
              <div className="contact-box contact-size">
                <div className="contact-box__left">
                  <div className="contact-size">
                    <h2 className="c-ttl__02 mbsp-14">サイズ分布</h2>
                    <div className="contact-size__table">
                      <table>
                        <tr>
                          <th>10.2</th>
                          <th>10.6</th>
                          <th>11.0</th>
                        </tr>
                        <tr>
                          <td>
                            <p><span>＊</span>：特注品</p>
                            <p><small>●</small>：常備品</p>
                          </td>
                          <td>
                            <p><span>＊</span>：特注品</p>
                            <p><small>●</small>：常備品</p>
                          </td>
                          <td>
                            <p><span>＊</span>：特注品</p>
                            <p><small>●</small>：常備品</p>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div id="id-01" className="contact-id js-item">
                    <h2 className="c-ttl__02 mbpc-18 mbsp-22"> 【サイズ：10.6】フィッティングカーブ ✕ パワー分布 <small>（<strong>＊</strong>：特注品 /<b>●</b>：常備品）</small>
                    </h2>
                    <p className="contact-id__note">※表は左右にスクロールいただけます。</p>
                    <div className="contact-size__flex">
                      <div className="contact-size__flex-left">
                        <ul className="contact-size__list">
                          <li className="contact-size__list-item"> フィッティング<br />カーブ(0.5刻み) </li>
                          <li className="contact-size__list-item">39.00</li>
                          <li className="contact-size__list-item">39.50</li>
                          <li className="contact-size__list-item">40.00</li>
                          <li className="contact-size__list-item">40.50</li>
                          <li className="contact-size__list-item">41.00</li>
                          <li className="contact-size__list-item">41.50</li>
                          <li className="contact-size__list-item">42.00</li>
                          <li className="contact-size__list-item">42.50</li>
                          <li className="contact-size__list-item">43.00</li>
                          <li className="contact-size__list-item">43.50</li>
                          <li className="contact-size__list-item">44.00</li>
                          <li className="contact-size__list-item">44.50</li>
                          <li className="contact-size__list-item">45.00</li>
                          <li className="contact-size__list-item">45.50</li>
                          <li className="contact-size__list-item">46.00</li>
                          <li className="contact-size__list-item">46.50</li>
                          <li className="contact-size__list-item">47.00</li>
                        </ul>
                      </div>
                      <div className="contact-size__flex-right">
                        <div className="table-size">
                          <h2 className="table-size__ttl">パワー（0.5刻み）</h2>
                          <table>
                            <tr>
                              <th>-1.00</th>
                              <th>-1.50</th>
                              <th>-2.00</th>
                              <th>-2.50</th>
                              <th>-3.00</th>
                              <th>-3.50</th>
                              <th>-4.00</th>
                              <th>-4.50</th>
                              <th>-5.00</th>
                              <th>-5.50</th>
                              <th>-6.00</th>
                              <th>-6.50</th>
                              <th>-7.00</th>
                              <th>-7.50</th>
                              <th>-8.00</th>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td>
                                <p>ー</p>
                              </td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="id-02" className="contact-id js-item">
                    <h2 className="c-ttl__02 mbpc-18 mbsp-22"> 【サイズ：11.0】フィッティングカーブ ✕ パワー分布 <small>（<strong>＊</strong>：特注品）</small>
                    </h2>
                    <p className="contact-id__note">※表は左右にスクロールいただけます。</p>
                    <div className="contact-size__flex">
                      <div className="contact-size__flex-left">
                        <ul className="contact-size__list">
                          <li className="contact-size__list-item"> フィッティング<br />カーブ(0.5刻み) </li>
                          <li className="contact-size__list-item">39.00</li>
                          <li className="contact-size__list-item">39.50</li>
                          <li className="contact-size__list-item">40.00</li>
                          <li className="contact-size__list-item">40.50</li>
                          <li className="contact-size__list-item">41.00</li>
                          <li className="contact-size__list-item">41.50</li>
                          <li className="contact-size__list-item">42.00</li>
                          <li className="contact-size__list-item">42.50</li>
                          <li className="contact-size__list-item">43.00</li>
                          <li className="contact-size__list-item">43.50</li>
                          <li className="contact-size__list-item">44.00</li>
                          <li className="contact-size__list-item">44.50</li>
                          <li className="contact-size__list-item">45.00</li>
                          <li className="contact-size__list-item">45.50</li>
                          <li className="contact-size__list-item">46.00</li>
                          <li className="contact-size__list-item">46.50</li>
                          <li className="contact-size__list-item">47.00</li>
                        </ul>
                      </div>
                      <div className="contact-size__flex-right">
                        <div className="table-size">
                          <h2 className="table-size__ttl">パワー（0.5刻み）</h2>
                          <table>
                            <tr>
                              <th>-1.00</th>
                              <th>-1.50</th>
                              <th>-2.00</th>
                              <th>-2.50</th>
                              <th>-3.00</th>
                              <th>-3.50</th>
                              <th>-4.00</th>
                              <th>-4.50</th>
                              <th>-5.00</th>
                              <th>-5.50</th>
                              <th>-6.00</th>
                              <th>-6.50</th>
                              <th>-7.00</th>
                              <th>-7.50</th>
                              <th>-8.00</th>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td>
                                <p>ー</p>
                              </td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="id-03" className="contact-id js-item">
                    <h2 className="c-ttl__02 mbpc-18 mbsp-22"> 【サイズ：10.2】フィッティングカーブ ✕ パワー分布 <small>（<strong>＊</strong>：特注品）</small>
                    </h2>
                    <p className="contact-id__note">※表は左右にスクロールいただけます。</p>
                    <div className="contact-size__flex">
                      <div className="contact-size__flex-left">
                        <ul className="contact-size__list">
                          <li className="contact-size__list-item"> フィッティング<br />カーブ(0.5刻み) </li>
                          <li className="contact-size__list-item">39.00</li>
                          <li className="contact-size__list-item">39.50</li>
                          <li className="contact-size__list-item">40.00</li>
                          <li className="contact-size__list-item">40.50</li>
                          <li className="contact-size__list-item">41.00</li>
                          <li className="contact-size__list-item">41.50</li>
                          <li className="contact-size__list-item">42.00</li>
                          <li className="contact-size__list-item">42.50</li>
                          <li className="contact-size__list-item">43.00</li>
                          <li className="contact-size__list-item">43.50</li>
                          <li className="contact-size__list-item">44.00</li>
                          <li className="contact-size__list-item">44.50</li>
                          <li className="contact-size__list-item">45.00</li>
                          <li className="contact-size__list-item">45.50</li>
                          <li className="contact-size__list-item">46.00</li>
                          <li className="contact-size__list-item">46.50</li>
                          <li className="contact-size__list-item">47.00</li>
                        </ul>
                      </div>
                      <div className="contact-size__flex-right">
                        <div className="table-size">
                          <h2 className="table-size__ttl">パワー（0.5刻み）</h2>
                          <table>
                            <tr>
                              <th>-1.00</th>
                              <th>-1.50</th>
                              <th>-2.00</th>
                              <th>-2.50</th>
                              <th>-3.00</th>
                              <th>-3.50</th>
                              <th>-4.00</th>
                              <th>-4.50</th>
                              <th>-5.00</th>
                              <th>-5.50</th>
                              <th>-6.00</th>
                              <th>-6.50</th>
                              <th>-7.00</th>
                              <th>-7.50</th>
                              <th>-8.00</th>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td>
                                <p>ー</p>
                              </td>
                            </tr>
                            <tr>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                            </tr>
                            <tr>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><small>●</small></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td>
                                <p>ー</p>
                              </td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                            <tr>
                              <td>
                                <p>ー</p>
                              </td>
                              <td>
                                <p>ー</p>
                              </td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                              <td><span>＊</span></td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {shouldDisplayHD && (<div id="id-04" className="contact-id js-item">
                    <h2 className="c-ttl__02 mbpc-18 mbsp-22"> 【サイズ：10.2／10.6／11.0】ブレスオーコレクトHD フィッティングカーブ ✕ パワー分布 <small>（<strong>＊</strong>：特注品）</small>
                    </h2>
                      <p className="contact-id__note">※表は左右にスクロールいただけます。</p>
                      <div className="contact-size__flex">
                        <div className="contact-size__flex-left">
                          <ul className="contact-size__list">
                            <li className="contact-size__list-item"> フィッティング<br />カーブ(0.5刻み) </li>
                            <li className="contact-size__list-item">39.00</li>
                            <li className="contact-size__list-item">39.50</li>
                            <li className="contact-size__list-item">40.00</li>
                            <li className="contact-size__list-item">40.50</li>
                            <li className="contact-size__list-item">41.00</li>
                            <li className="contact-size__list-item">41.50</li>
                            <li className="contact-size__list-item">42.00</li>
                            <li className="contact-size__list-item">42.50</li>
                            <li className="contact-size__list-item">43.00</li>
                            <li className="contact-size__list-item">43.50</li>
                            <li className="contact-size__list-item">44.00</li>
                            <li className="contact-size__list-item">44.50</li>
                            <li className="contact-size__list-item">45.00</li>
                            <li className="contact-size__list-item">45.50</li>
                            <li className="contact-size__list-item">46.00</li>
                            <li className="contact-size__list-item">46.50</li>
                            <li className="contact-size__list-item">47.00</li>
                          </ul>
                        </div>
                        <div className="contact-size__flex-right">
                          <div className="table-size">
                            <h2 className="table-size__ttl">パワー（0.5刻み）</h2>
                            <table>
                              <tr>
                                <th>-1.00</th>
                                <th>-1.50</th>
                                <th>-2.00</th>
                                <th>-2.50</th>
                                <th>-3.00</th>
                                <th>-3.50</th>
                                <th>-4.00</th>
                                <th>-4.50</th>
                                <th>-5.00</th>
                                <th>-5.50</th>
                                <th>-6.00</th>
                                <th>-6.50</th>
                                <th>-7.00</th>
                                <th>-7.50</th>
                                <th>-8.00</th>
                              </tr>
                              <tr>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td>
                                  <p>ー</p>
                                </td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                              <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {shouldDisplayTD && (
                    <div id="id-05" className="contact-id js-item">
                      <h2 className="c-ttl__02 mbpc-18 mbsp-22"> 【サイズ：10.2／10.6／11.0】ブレスオーコレクトTD フィッティングカーブ ✕ パワー分布 <small>（<strong>＊</strong>：特注品）</small></h2>
                      <h2 className="c-ttl__02 mbpc-18 mbsp-22"> 【CYL：1.00／1.50／2.00／2.50／3.00】</h2>
                      <p className="contact-id__note">※表は左右にスクロールいただけます。</p>
                      <div className="contact-size__flex">
                        <div className="contact-size__flex-left">
                          <ul className="contact-size__list">
                            <li className="contact-size__list-item"> フィッティング<br />カーブ(0.5刻み) </li>
                            <li className="contact-size__list-item">39.00</li>
                            <li className="contact-size__list-item">39.50</li>
                            <li className="contact-size__list-item">40.00</li>
                            <li className="contact-size__list-item">40.50</li>
                            <li className="contact-size__list-item">41.00</li>
                            <li className="contact-size__list-item">41.50</li>
                            <li className="contact-size__list-item">42.00</li>
                            <li className="contact-size__list-item">42.50</li>
                            <li className="contact-size__list-item">43.00</li>
                            <li className="contact-size__list-item">43.50</li>
                            <li className="contact-size__list-item">44.00</li>
                            <li className="contact-size__list-item">44.50</li>
                            <li className="contact-size__list-item">45.00</li>
                            <li className="contact-size__list-item">45.50</li>
                            <li className="contact-size__list-item">46.00</li>
                            <li className="contact-size__list-item">46.50</li>
                            <li className="contact-size__list-item">47.00</li>
                          </ul>
                        </div>
                        <div className="contact-size__flex-right">
                          <div className="table-size">
                            <h2 className="table-size__ttl">パワー（0.5刻み）</h2>
                            <table>
                              <tr>
                                <th>-1.00</th>
                                <th>-1.50</th>
                                <th>-2.00</th>
                                <th>-2.50</th>
                                <th>-3.00</th>
                                <th>-3.50</th>
                                <th>-4.00</th>
                                <th>-4.50</th>
                                <th>-5.00</th>
                                <th>-5.50</th>
                                <th>-6.00</th>
                                <th>-6.50</th>
                                <th>-7.00</th>
                                <th>-7.50</th>
                                <th>-8.00</th>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td>
                                  <p>ー</p>
                                </td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                              <tr>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td>
                                  <p>ー</p>
                                </td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                                <td><span>＊</span></td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="contact-box__right">
                  <ul className="sidebar-list mbsp-36 js-scroll">
                    <li className="sidebar-list__item active"><a href="#id-01">サイズ：10.6</a></li>
                    <li className="sidebar-list__item"><a href="#id-02">サイズ：11.0</a></li>
                    <li className="sidebar-list__item"><a href="#id-03">サイズ：10.2</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default Main;
